var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftware3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 32H98.66A8 8 0 0 1 106.66 40V98.66A8 8 0 0 1 98.66 106.66H40A8 8 0 0 1 32 98.66V40A8 8 0 0 1 40 32ZM40 149.34H98.66A8 8 0 0 1 106.66 157.34V216A8 8 0 0 1 98.66 224H40A8 8 0 0 1 32 216V157.34A8 8 0 0 1 40 149.34ZM157.34 149.34H216A8 8 0 0 1 224 157.34V216A8 8 0 0 1 216 224H157.34A8 8 0 0 1 149.34 216V157.34A8 8 0 0 1 157.34 149.34ZM186.66 32V106.66M149.34 69.34H224",
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware3);
export default __webpack_public_path__ + "static/media/software-3.a51de4777aedba6507a1fb8af7ae082c.svg";
export { ForwardRef as ReactComponent };